import { AccountsAPI } from "../apis";
import auth from "../common/Auth";

export const getAccounts = (props, context) => {
    
    const token = auth.getAccessToken();
    const accountsAPI = new AccountsAPI(token);

    return accountsAPI.getAll();
}
